import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useWA, useLoad, useDebounced, PageHead, Card, Tabs, Btn, Modal, Field, Search, Skeleton, Empty, ErrorBox, num, fdate } from "../ui";

function CatModal({ item, cats, onClose, onDone }) {
  const { run } = useWA();
  const [name, setName] = useState(item ? item.name : "");
  const [slug, setSlug] = useState(item ? item.slug : "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await run("categorySave", { id: item && item.id, name, slug }, item ? "Category बदल गई" : "Category बन गई");
      onDone();
    } catch (e) {
      setBusy(false);
    }
  };
  return (
    <Modal open onClose={onClose} title={item ? "Category edit" : "नई category"} width={460}
      footer={<><Btn onClick={onClose}>रद्द</Btn><Btn variant="primary" loading={busy} onClick={save}>Save</Btn></>}>
      <Field label="नाम"><input autoFocus className="wa-input" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} /></Field>
      <Field label="Slug (URL)" hint="खाली छोड़ें तो नाम से बनेगा" className="mt-3"><input className="wa-input" value={slug} onChange={(e) => setSlug(e.target.value)} /></Field>
    </Modal>
  );
}

function DeleteCat({ item, cats, onClose, onDone }) {
  const { run } = useWA();
  const [moveTo, setMoveTo] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await run("categoryDelete", { id: item.id, moveTo: moveTo || null }, "Category हट गई");
      onDone();
    } catch (e) {
      setBusy(false);
    }
  };
  return (
    <Modal open onClose={onClose} title={`"${item.name}" हटाएँ?`} width={460}
      footer={<><Btn onClick={onClose}>रद्द</Btn><Btn variant="danger" loading={busy} onClick={go}>हाँ, हटाएँ</Btn></>}>
      <p className="text-sm wa-muted mb-3">इस category में <b>{item.blogs}</b> blogs हैं। Blogs delete नहीं होंगे — उन्हें कहाँ भेजें?</p>
      <select className="wa-input" value={moveTo} onChange={(e) => setMoveTo(e.target.value)}>
        <option value="">बिना category छोड़ दें</option>
        {cats.filter((c) => c.id !== item.id).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
    </Modal>
  );
}

function CategoriesTab() {
  const { data, loading, error, reload } = useLoad("categories");
  const [edit, setEdit] = useState(null);
  const [del, setDel] = useState(null);
  const items = (data && data.items) || [];
  return (
    <>
      <ErrorBox msg={error} retry={reload} />
      <Card title="Categories" subtitle={data ? `${items.length} categories · ${num(data.uncategorized)} blogs बिना category` : ""} actions={<Btn variant="primary" icon="fa-solid fa-plus" onClick={() => setEdit({})}>नई category</Btn>} pad={false}>
        {loading && !data ? <div className="p-4"><Skeleton rows={5} /></div> : !items.length ? <Empty icon="fa-solid fa-folder-tree" title="कोई category नहीं" /> : (
          <div className="overflow-x-auto">
            <table className="wa-tbl">
              <thead><tr><th>नाम</th><th>Slug</th><th className="text-right">Blogs</th><th className="hidden md:table-cell">बनी</th><th /></tr></thead>
              <tbody>
                {items.map((c) => (
                  <tr key={c.id}>
                    <td className="font-semibold">{c.name}</td>
                    <td className="wa-muted text-[12.5px]">{c.slug}</td>
                    <td className="text-right tabular-nums"><Link to={`/website/blogs?category=${c.id}`} className="hover:underline">{num(c.blogs)}</Link></td>
                    <td className="hidden md:table-cell wa-muted text-[12.5px]">{fdate(c.at)}</td>
                    <td className="text-right whitespace-nowrap">
                      <Btn size="sm" icon="fa-regular fa-pen-to-square" onClick={() => setEdit(c)} aria-label="Edit" />
                      <Btn size="sm" className="ml-1 !text-rose-600" icon="fa-regular fa-trash-can" onClick={() => setDel(c)} aria-label="Delete" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
      {edit && <CatModal item={edit.id ? edit : null} cats={items} onClose={() => setEdit(null)} onDone={() => { setEdit(null); reload(); }} />}
      {del && <DeleteCat item={del} cats={items} onClose={() => setDel(null)} onDone={() => { setDel(null); reload(); }} />}
    </>
  );
}

function TagsTab() {
  const { run, confirm, prompt } = useWA();
  const [q, setQ] = useState("");
  const dq = useDebounced(q);
  const { data, loading, error, reload } = useLoad("tags", { q: dq }, [dq]);
  const items = (data && data.items) || [];
  const unused = items.filter((t) => t.blogs === 0).length;

  const add = async () => {
    const name = await prompt({ title: "नया tag", placeholder: "tag का नाम" });
    if (!name) return;
    try { await run("tagSave", { name }, "Tag बन गया"); reload(); } catch (e) { /* toast */ }
  };
  const rename = async (t) => {
    const name = await prompt({ title: "Tag का नाम बदलें", defaultValue: t.name });
    if (!name || name === t.name) return;
    try { await run("tagSave", { id: t.id, name }, "Tag बदल गया"); reload(); } catch (e) { /* toast */ }
  };
  const remove = async (t) => {
    if (!(await confirm({ title: `#${t.name} हटाएँ?`, text: `${t.blogs} blogs से यह tag हट जाएगा (blogs नहीं हटेंगे)।`, danger: true }))) return;
    try { await run("tagDelete", { id: t.id }, "Tag हट गया"); reload(); } catch (e) { /* toast */ }
  };
  const cleanup = async () => {
    if (!(await confirm({ title: `${unused} बिना इस्तेमाल वाले tags हटाएँ?`, danger: true }))) return;
    try { await run("tagsCleanup", {}, "बेकार tags साफ़ हो गए"); reload(); } catch (e) { /* toast */ }
  };

  return (
    <>
      <ErrorBox msg={error} retry={reload} />
      <Card title="Tags" subtitle={`${items.length} tags${unused ? ` · ${unused} किसी blog में नहीं` : ""}`}
        actions={<>{unused > 0 && <Btn icon="fa-solid fa-broom" onClick={cleanup}>बेकार tags साफ़ करें</Btn>}<Btn variant="primary" icon="fa-solid fa-plus" onClick={add}>नया tag</Btn></>}>
        <Search value={q} onChange={setQ} placeholder="Tag खोजें…" className="mb-4 max-w-sm" />
        {loading && !data ? <Skeleton rows={3} /> : !items.length ? <Empty icon="fa-solid fa-hashtag" title="कोई tag नहीं" /> : (
          <div className="flex flex-wrap gap-2">
            {items.map((t) => (
              <span key={t.id} className="group inline-flex items-center gap-1.5 pl-3 pr-1 h-8 rounded-full border wa-line text-[13px]" style={t.blogs === 0 ? { opacity: 0.55 } : {}}>
                <b>#{t.name}</b>
                <span className="text-[11px] wa-muted tabular-nums">{t.blogs}</span>
                <button type="button" onClick={() => rename(t)} className="w-6 h-6 rounded-full hover:bg-slate-500/10" aria-label={`Rename ${t.name}`}><i className="fa-solid fa-pen text-[10px]" /></button>
                <button type="button" onClick={() => remove(t)} className="w-6 h-6 rounded-full hover:bg-rose-500/15 text-rose-500" aria-label={`Delete ${t.name}`}><i className="fa-solid fa-xmark text-[11px]" /></button>
              </span>
            ))}
          </div>
        )}
      </Card>
    </>
  );
}

export default function Categories() {
  const [tab, setTab] = useState("cats");
  return (
    <div>
      <PageHead icon="fa-solid fa-tags" title="Categories & Tags" subtitle="Blogs को group करने के लिए" actions={<Tabs tabs={[["cats", "Categories"], ["tags", "Tags"]]} value={tab} onChange={setTab} />} />
      {tab === "cats" ? <CategoriesTab /> : <TagsTab />}
    </div>
  );
}
